<template>
  <v-row>
    <v-col cols="12">
      <v-form class="ma-6 pa-0">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dates"
                  label="Дата оплаты"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                range
                locale="ru-RU"
                :first-day-of-week="1"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Отмена
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(dates)">
                  Сохранить
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="objSelect"
              :items="obj"
              item-text="NAME"
              item-value="ID"
              label="Объект"
              outlined
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-btn
          text
          color="success"
          class="mr-4"
          @click="getReport"
          :disabled="loading"
        >
          Сформировать
        </v-btn>
        <v-btn
          text
          color="orange"
          class="mr-4"
          @click="exportXls"
          :disabled="loading"
        >
          Выгрузить XLS
        </v-btn>
      </v-form>
    </v-col>
    <v-col>
      <template>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr class="gray">
                <th class="text-center">
                  ФИО
                </th>
                <th :colspan="colspan" class="text-center orange">
                  Объекты
                </th>
                <th class="text-left success">
                  Итого
                </th>
              </tr>
            </thead>
            <template v-if="loading === true">
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                top
                color="light-green darken-4"
                height="10"
              ></v-progress-linear>
            </template>
            <tbody v-if="objEmployed.length > 0">
              <tr>
                <td></td>
                <td v-for="obj in objEmployed" :key="obj" class="orange">
                  {{ obj }}
                </td>
                <td class="success"></td>
              </tr>
              <template v-for="item in reportData">
                <tr :key="item.name">
                  <td>{{ item.name }}</td>
                  <template v-for="obj in item.obj">
                    <td :key="obj.title" class="orange">{{ obj.sum }}</td>
                  </template>
                  <td class="success">{{ item.total }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import exeljs from "exceljs";
import fileWrite from "file-saver";

export default {
  name: "selfEmployed",
  data() {
    return {
      loading: false,
      menu: false,
      colspan: 1,
      items: [],
      employedData: [],
      selfEmployed: [],
      obj: [],
      objEmployed: [],
      objSelect: "",
      dates: [],
      normalDate: [],
      reportData: [],
      contragentDatas: [],
      url: "https://citystroi.bitrix24.ru/rest/73/gjdt5g3y10jxw3r9/",
    };
  },
  methods: {
    async getObj() {
      try {
        this.obj = [];
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "97",
        };
        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          const objData = await axios.post(this.url + method, params);
          next = objData.data.next;
          for (const elem of objData.data.result) {
            this.obj.push(elem);
          }
          if (!next) {
            i = 0;
          }
        }
        //console.log(this.obj)
        this.obj.sort((a, b) => {
          if (a["NAME"] < b["NAME"]) {
            return -1;
          }
          if (a["NAME"] > b["NAME"]) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getReport() {
      try {
        this.loading = true;
        this.normalDate = [];
        this.employedData = [];
        this.selfEmployed = [];
        this.objEmployed = [];
        this.colspan = 1;
        this.items = [];
        this.reportData = [];
        const selfEmployed = [];
        const objEmployed = [];
        const employedData = [];

        await this.normalizeDate();
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "45",
          FILTER: {
            ">=PROPERTY_691": this.normalDate[0],
            "<=PROPERTY_691": this.normalDate[1],
          },
        };
        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          if (this.objSelect) params["FILTER"]["PROPERTY_973"] = this.objSelect;
          const reportData = await axios.post(this.url + method, params);
          next = reportData.data.next;
          for (const elem of reportData.data.result) {
            if (
              elem["PROPERTY_1019"] &&
              Object.values(elem["PROPERTY_1019"])[0] !== " "
            ) {
              if (
                elem["NAME"] === "Входящий счет" ||
                elem["NAME"] === "Выдача наличных средств" ||
                elem["NAME"] === "Согласование и оплата расходов (Нал/Безнал)"
              ) {
                const item = {
                  id: elem["ID"],
                  contragent: "",
                  obj: "",
                  title: elem["NAME"],
                  createDate: elem["DATE_CREATE"],
                  comments: elem["PREVIEW_TEXT"],
                  datePay: "",
                  sumPay: 0,
                  sumPayNoTax: 0,
                  tax: 0,
                  sumPayXLS: 0,
                  sumPayNoTaxXLS: 0,
                  taxXLS: 0,
                };
                if (elem["PROPERTY_973"])
                  item.obj = this.obj.filter((e) => {
                    return e["ID"] == Object.values(elem["PROPERTY_973"]);
                  })[0]["NAME"];
                if (elem["PROPERTY_691"])
                  item.datePay = Object.values(elem["PROPERTY_691"])[0];
                if (elem["PROPERTY_1019"])
                  item.contragent = Object.values(elem["PROPERTY_1019"])[0];
                if (elem["PROPERTY_591"])
                  item.sumPayXLS = Number(
                    Object.values(elem["PROPERTY_591"])[0]
                  );
                if (elem["PROPERTY_587"])
                  item.sumPayNoTaxXLS = Number(
                    Object.values(elem["PROPERTY_587"])[0]
                  );
                if (elem["PROPERTY_589"])
                  item.taxXLS = Number(Object.values(elem["PROPERTY_589"])[0]);
                if (elem["PROPERTY_591"])
                  item.sumPay = new Intl.NumberFormat("ru-RU", {
                    minimumFractionDigits: 2,
                  }).format(Object.values(elem["PROPERTY_591"]));
                if (elem["PROPERTY_587"])
                  item.sumPayNoTax = new Intl.NumberFormat("ru-RU", {
                    minimumFractionDigits: 2,
                  }).format(Object.values(elem["PROPERTY_587"]));
                if (elem["PROPERTY_589"])
                  item.tax = new Intl.NumberFormat("ru-RU", {
                    minimumFractionDigits: 2,
                  }).format(Object.values(elem["PROPERTY_589"]));
                this.items.push(item);
              }
            }
          }
          if (!next) {
            i = 0;
          }
        }
        let batchParams = {
          halt: 0,
          cmd: {},
        };
        for (const index in this.items) {
          let id =
            this.items[index].contragent.substr(0, 2) == "CO"
              ? this.items[index].contragent.substr(3)
              : this.items[index].contragent;
          batchParams.cmd[`company${index}`] = `crm.company.get?id=${id}`;
          if (index == this.items.length - 1) {
            await this.batch(batchParams, index);
            await console.log(this.contragentDatas, "contragent");
          }
          if (Object.keys(batchParams.cmd).length === 50) {
            await this.batch(batchParams, index);
            batchParams = {
              halt: 0,
              cmd: {},
            };
          }
        }
        for (const index in this.items) {
          console.log(this.items[index].contragent, "item contragent");
          let id =
            this.items[index].contragent.substr(0, 2) == "CO"
              ? this.items[index].contragent.substr(3)
              : this.items[index].contragent;
          const contragent = this.contragentDatas.filter((e) => {
            return e["ID"] == id;
          });
          if (contragent.length > 0) {
            if (contragent[0]["COMPANY_TYPE"] == "SUPPLIER") {
              this.items[index].contragent = contragent[0]["TITLE"];
              selfEmployed.push(contragent[0]["TITLE"]);
              objEmployed.push(this.items[index].obj);
              employedData.push(this.items[index]);
            }
          }
        }
        this.formatReport(employedData, selfEmployed, objEmployed);
      } catch (e) {
        console.log(e);
      }
    },
    async batch(batchParams) {
      try {
        const resultBatch = await axios.post(this.url + "batch", batchParams);
        for (const i in resultBatch.data.result.result) {
          this.contragentDatas.push(resultBatch.data.result.result[i]);
        }
      } catch (e) {
        console.log(e);
      }
    },
    formatReport(data, selfEmployed, objEmployed) {
      this.objEmployed = Array.from(new Set(objEmployed));
      this.selfEmployed = Array.from(new Set(selfEmployed));
      this.colspan = this.objEmployed.length;
      for (const selfEmployed of this.selfEmployed) {
        const result = data.filter((e) => {
          return e.contragent == selfEmployed;
        });
        const item = {
          name: selfEmployed,
          obj: [],
          total: 0,
          totalXls: 0,
        };
        for (const obj of this.objEmployed) {
          item.obj.push({ title: obj, sum: 0, sumXls: 0 });
        }
        for (const elem of result) {
          for (const obj of item.obj) {
            if (elem.obj == obj.title) {
              obj.sumXls += elem.sumPayXLS;
            }
          }
          item.totalXls += elem.sumPayXLS;
        }
        item.total = new Intl.NumberFormat("ru-RU", {
          minimumFractionDigits: 2,
        }).format(item.totalXls);
        for (const obj of item.obj) {
          obj.sum = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(obj.sumXls);
        }
        this.reportData.push(item);
      }
      console.log(this.reportData);
      this.loading = false;
    },
    async exportXls() {
      try {
        const workbook = new exeljs.Workbook();
        workbook.views = [
          {
            x: 0,
            y: 500,
            width: 29040,
            height: 15840,
            visibility: "visible",
          },
        ];
        const worksheet = workbook.addWorksheet("Отчет по самозанятым");

        const worksheetData = [];
        for (const elem of this.reportData) {
          const item = {
            name: elem.name,
            total: elem.totalXls,
          };
          for (const index in elem.obj) {
            item[`obj${index}`] = elem.obj[index].sumXls;
          }
          worksheetData.push(item);
        }
        worksheet.columns = [
          { header: "ФИО", key: "name", width: 19 },
          ...this.objEmployed.map((item, index) => ({
            header: item,
            key: `obj${index}`,
            width: 19,
            style: { numFmt: "#,0.00" },
          })),
          {
            header: "Итого",
            key: "total",
            width: 19,
            style: { numFmt: "#,0.00" },
          },
        ];
        for (const row of worksheetData) {
          const xlsRow = worksheet.addRow(row);
          xlsRow.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "B9B7BD" },
          };
          xlsRow.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
        const buffer = await workbook.xlsx.writeBuffer();
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([buffer], { type: fileType });
        fileWrite(blob, "report.xlsx");
      } catch (e) {
        console.log(e);
      }
    },
    async normalizeDate() {
      try {
        const firstDate = this.dates[0].split("-");
        const twoDate = this.dates[1].split("-");
        const firstDateFormated =
          firstDate[2] + "." + firstDate[1] + "." + firstDate[0] + " 00:00:00";
        const twoDateFormated =
          twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
        this.normalDate.push(firstDateFormated);
        this.normalDate.push(twoDateFormated);
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.getObj();
  },
};
</script>

<style scoped></style>
